const GLOWS = [
  // Main base glow spanning the bottom
  '-bottom-[20vh] left-0 right-0 h-[55vh] rounded-[50%] bg-brand-green-primary-1 opacity-90 blur-[100px]',

  // Left cluster
  '-bottom-[10vh] -left-[18vw] h-[60vh] w-[55vh] rounded-full bg-brand-green-primary-3 opacity-60 blur-[130px]',
  '-bottom-[5vh] -left-[8vw] h-[50vh] w-[38vh] rounded-full bg-brand-green-primary-2 opacity-65 blur-[120px]',
  '-bottom-[12vh] left-[10%] h-[42vh] w-[42vh] rounded-full bg-brand-green-primary-2 opacity-45 blur-[140px]',

  // Right cluster (mirror of left)
  '-bottom-[10vh] -right-[18vw] h-[60vh] w-[55vh] rounded-full bg-brand-green-primary-3 opacity-60 blur-[130px]',
  '-bottom-[5vh] -right-[8vw] h-[50vh] w-[38vh] rounded-full bg-brand-green-primary-2 opacity-65 blur-[120px]',
  '-bottom-[12vh] right-[10%] h-[42vh] w-[42vh] rounded-full bg-brand-green-primary-2 opacity-45 blur-[140px]',

  // Center highlights
  '-bottom-[18vh] left-[20%] right-[20%] h-[38vh] rounded-full bg-brand-green-primary-2 opacity-55 blur-[120px]',
  '-bottom-[8vh] left-[30%] right-[30%] h-[24vh] rounded-full bg-brand-green-primary-3 opacity-40 blur-[110px]',
]

export const GradientBackdrop = () => {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
      {GLOWS.map((glow, index) => (
        <div key={index} className={`absolute ${glow}`} />
      ))}
    </div>
  )
}
